import './specificPost.scss';
import { connect } from 'react-redux';
import { FC, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'tedooo-web-design-system/ui';
import { ArrowRight } from 'tedooo-web-design-system/icons';

import {
  getPost as getPostInfo,
  getShopImage as getShopImagesAction,
} from 'store/specificPost/SpecificPostActions';
import { UserSelector } from 'store/user/UserSelector';
import PostWrapper from './PostWrapper';
import { SpecificPostSelector } from 'store/specificPost/SpecificPostSelectors';
import { IStore2, IMyPost, IPost } from 'types';
import ProfileCard from 'components/profileCard/ProfileCard';
import { ROUTES } from 'constant';
import { SpecificPostSlicer } from 'store/specificPost/SpecificPostSlicer';
import { useRequireToken } from 'hooks/useRequireToken';
import { translations } from 'translations/en';
import { onFollowUserToggle } from 'store/profile/ProfileActions';
import SideBarFooter from 'pages/feed/profileSideBar/sideBarFooter/SideBarFooter';

export interface ISpecificPost {
  posts: Array<IMyPost>;
  token?: string;
  post: IPost | null;
  isPostOwner: boolean;
  coverPhoto: string | null;
  isFollowing: boolean;
  userId: string | null;
  totalFollowing: number;
  totalFollowers: number;
  onFollow(arg: { userId: string; isFollowing: boolean }): void;
  getShopImage(input: { id: string; token?: string }): void;
  resetPost(): void;
  getPost(input: { id: string; token?: string }): void;
}

const SpecificPost: FC<ISpecificPost> = ({
  isFollowing,
  userId,
  totalFollowing,
  totalFollowers,
  getPost,
  getShopImage,
  isPostOwner,
  onFollow,
  token,
  post,
  coverPhoto,
  resetPost,
}) => {
  const { id } = useParams();

  const navigate = useNavigate();

  const isReadOnly = !token;

  const isPremium = !!post?.userDetails.isPremium;

  const isVisionSeller = !!post?.userDetails.isVisionSeller;

  const onViewProfileClick = useRequireToken(() => {
    navigate(`/${ROUTES.USER}/${post?.userDetails.userId}`);
  });

  const onBackClick = () => {
    navigate(-1);
  };

  const onFollowToggle = useRequireToken(() => {
    onFollow({ isFollowing, userId: userId || '' });
  });

  useEffect(() => {
    if (id) {
      getPost({ id, token });
    }
  }, [id]);

  useEffect(() => {
    return () => resetPost();
  }, []);

  useEffect(() => {
    if (post?.shopId && !isPostOwner) {
      getShopImage({ id: post.shopId, token });
    }
  }, [post?.shopId, isPostOwner, token]);

  return (
    <div className="page specific-post-page feed-layout" id="feed-container">
      <div className="preview">
        <Button
          type="secondary"
          size="medium"
          borderRadius="small"
          prefixIcon={<ArrowRight />}
          text={translations.FEED.SPECIFIC_POST.BACK_TO_FEED}
          onClick={onBackClick}
          className="back-button"
        />
        <PostWrapper shouldDisplayImages post={post} />
      </div>
      <div className="list">
        {post && (
          <>
            <ProfileCard
              key={post.id}
              onViewProfileClick={onViewProfileClick}
              shouldShowFollowButton
              isFollowing={post.isFollowing}
              onFollowToggle={onFollowToggle}
              avatar={post.userDetails.avatar}
              shopName={post.userDetails.shopName}
              username={post.userDetails.username}
              showPopup={() => {}}
              coverPhoto={coverPhoto}
              totalFollowers={totalFollowers}
              totalFollowing={totalFollowing}
              isReadOnly={isReadOnly}
              isUserProfileCard={isPostOwner}
              isPremium={isPremium}
              isVisionSeller={isVisionSeller}
            />
            <SideBarFooter />
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IStore2) => {
  const { token, shopDetails } = state.user;

  const details = shopDetails || { coverPhoto: null, productImages: [] };

  const {
    coverPhoto: specificCoverPhoto,
    isFollowing,
    userDetails,
    totalFollowing,
    totalFollowers,
  } = state.specificPost;

  const userId = userDetails?.userId || null;

  const post = SpecificPostSelector.mainPostSelector(state);

  const loggedInUserId = UserSelector.loggedUserIdSelector(state);

  const isPostOwner = loggedInUserId === post?.userDetails?.userId;

  const coverPhoto = isPostOwner ? details.coverPhoto : specificCoverPhoto;

  const shopName = UserSelector.shopNameSelector(state);

  return {
    post,
    token,
    shopName,
    coverPhoto,
    isPostOwner,
    isFollowing,
    userId,
    totalFollowing,
    totalFollowers,
  };
};

const mapDispatchToProps = {
  getPost: getPostInfo,
  getShopImage: getShopImagesAction,
  onFollow: onFollowUserToggle,
  resetPost: SpecificPostSlicer.actions.reset,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpecificPost);
